import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
const stages = [{
  name: 'Proposed',
  tooltip: 'Initial wine label draft created and submitted',
  completed: true
}, {
  name: 'Substantiate',
  tooltip: 'Add supporting evidence and TTB documentation',
  completed: true
}, {
  name: 'Review',
  tooltip: 'Legal and TTB compliance review process',
  completed: false
}, {
  name: 'Approval',
  tooltip: 'Final approval from stakeholders',
  completed: false
}, {
  name: 'Published',
  tooltip: 'Label is approved and ready for production',
  completed: false
}];
export function WorkflowStepper() {
  return <div className="bg-white border-b border-gray-200" data-id="element-93">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-94">
        <div className="flex items-center justify-between" data-id="element-95">
          {stages.map((stage, index) => <Fragment key={stage.name} data-id="element-96">
              <div className="flex flex-col items-center relative group" data-id="element-97">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-200
                    ${stage.completed ? 'bg-purple-700 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-98">
                  {stage.completed ? <Check className="w-5 h-5 animate-scale-in" data-id="element-99" /> : <span className="text-sm font-medium" data-id="element-100">{index + 1}</span>}
                </div>
                <span className={`mt-2 text-sm font-medium ${stage.completed ? 'text-purple-700' : 'text-gray-500'}`} data-id="element-101">
                  {stage.name}
                </span>
                <div className="invisible group-hover:visible absolute bottom-full mb-2 w-48 p-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-center" data-id="element-102">
                  {stage.tooltip}
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 border-4 border-transparent border-t-gray-900" data-id="element-103" />
                </div>
              </div>
              {index < stages.length - 1 && <div className={`flex-1 h-px mx-4 transition-colors duration-200
                    ${stage.completed ? 'bg-purple-700' : 'bg-gray-200'}`} data-id="element-104" />}
            </Fragment>)}
        </div>
      </div>
    </div>;
}